// src/utils/api.js
import axiosInstance from "../../../../../api/axiosInstance";

const BASE = "/store_settings";

export async function getSettings(businessId) {
  const { data } = await axiosInstance.get(BASE, {
    params: { businessId }, // ?businessId=...
  });
  return data;
}

export async function saveSettings(businessId, payload) {
  await axiosInstance.put(BASE, payload, {
    params: { businessId }, // ?businessId=...
  });
}
